/**
 * RestoreReferralDialog - Restore non-admitted referral dialog
 * Extracted from ReferralsPage to reduce file size
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RotateCcw, Clock } from "lucide-react";

export function RestoreReferralDialog({
  open,
  onOpenChange,
  selectedReferral,
  restoring,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-primary">
            <RotateCcw className="w-5 h-5" />
            Restore Referral
          </DialogTitle>
          <DialogDescription>
            Restore this referral from Non-Admit back to active status.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
            <p className="text-sm text-amber-800 font-medium mb-1">
              ⚠️ Workflow will be reset
            </p>
            <p className="text-xs text-amber-700">
              All workflow progress will be cleared and the referral will start fresh from Pending status. 
              This allows the intake process to begin again from the insurance verification step.
            </p>
          </div>
          
          <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-xs text-blue-700">
              <strong>What will be reset:</strong>
            </p>
            <ul className="text-xs text-blue-600 mt-1 list-disc list-inside space-y-0.5">
              <li>Insurance approval status</li>
              <li>MD order and notes progress</li>
              <li>Assessment scheduling</li>
              <li>All other workflow steps</li>
            </ul>
            {selectedReferral?.client_id && (
              <p className="text-xs text-blue-700 mt-2">
                The client&apos;s status will also be updated to active.
              </p>
            )}
          </div>
        </div>
        
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={restoring}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={restoring}
            data-testid="confirm-restore-btn"
          >
            {restoring ? (
              <>
                <Clock className="w-4 h-4 mr-2 animate-spin" />
                Restoring...
              </>
            ) : (
              <>
                <RotateCcw className="w-4 h-4 mr-2" />
                Restore Referral
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
